import { Component, EventEmitter, OnDestroy, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FileSelectEvent } from "primeng/fileupload";
import { Subscription } from "rxjs";

@Component({
  selector: "app-file-upload",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.scss"]
})
export class FileUploadComponent implements OnDestroy {
  @Output() certificateData = new EventEmitter<{ formData: FormData; valid: boolean }>();

  certificate = new FormData();

  certificateForm = new FormGroup({
    senha: new FormControl("", [Validators.required])
  });

  $: Subscription[] = [];

  get senha() {
    return this.certificateForm.get("senha");
  }

  get hasFile() {
    return this.certificate.has("arquivo");
  }

  get isValid() {
    return this.certificateForm.valid && this.hasFile;
  }

  selectFile(event: FileSelectEvent) {
    const file = event.currentFiles[0];

    if (!file) {
      this.certificate.delete("arquivo");
      this.emitCertificateData();
      return;
    }

    this.certificate.set("arquivo", file);
    this.emitCertificateData();
  }

  emitCertificateData() {
    this.certificateData.emit({
      formData: this.certificate,
      valid: this.isValid
    });
  }

  constructor() {
    this.$.push(
      this.certificateForm.controls.senha.valueChanges.subscribe((senha) => {
        this.certificate.set("senha", senha ?? "");
        this.emitCertificateData();
      })
    );
  }

  ngOnDestroy(): void {
    this.$.forEach(($) => $.unsubscribe());
  }
}
